// extracted by mini-css-extract-plugin
module.exports = {"Container":"Image_Container__3sDwJ","Loading":"Image_Loading__336oq","Update":"Image_Update__2i8Qd"};